<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path d="M14.5 5H20.5" stroke="#7C7B7B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.5 8H17.5" stroke="#7C7B7B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21.5 11.5C21.5 16.75 17.25 21 12 21C6.75 21 2.5 16.75 2.5 11.5C2.5 6.25 6.75 2 12 2" stroke="#7C7B7B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M22.5 22L20.5 20" stroke="#7C7B7B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>